import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Modal } from 'flowbite';
import { UserRole } from 'src/app/models/enums';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { images } from 'src/images';

export interface NewTownPayload {
  name: string;
  latitude: number;
  longitude: number;
  timezone: string;
  clients: number[] | null;
}

@Component({
  selector: 'app-modal-new-town',
  templateUrl: './modal-new-town.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalNewTownComponent {
  @Input() id: string;
  @Input() modal: Modal;
  @Input() hidden: boolean = true;
  @Input() loading: boolean = false;
  @Input() clients: any[] = [];
  @Input() userRole: UserRole;
  @Output() action = new EventEmitter<NewTownPayload>();

  public images = images;
  public UserRole = UserRole;

  get canEditClients(): boolean {
    return this.userRole === UserRole.SUPERADMIN;
  }

  public name = '';
  public latitude: number | null = null;
  public longitude: number | null = null;
  public timezone = '';
  public timezones: { value: string; label: string }[] = [];
  public selectedClients: any[] = [];

  constructor(public literalService: LiteralService) {
    const zones: string[] = (Intl as any).supportedValuesOf?.('timeZone') ?? [];
    this.timezones = zones.map((tz) => ({ value: tz, label: tz }));
  }

  onTimezoneChange(event: any) {
    this.timezone = event?.value ?? '';
  }

  get isValid(): boolean {
    return (
      this.name.trim().length > 0 &&
      this.latitude !== null &&
      this.longitude !== null &&
      this.timezone.trim().length > 0 &&
      (!this.canEditClients || this.selectedClients.length > 0)
    );
  }

  reset() {
    this.name = '';
    this.latitude = null;
    this.longitude = null;
    this.timezone = '';
    this.selectedClients = [];
  }

  close() {
    this.reset();
    this.modal.hide();
  }

  onSubmit() {
    if (!this.isValid) return;
    this.action.emit({
      name: this.name.trim(),
      latitude: this.latitude as number,
      longitude: this.longitude as number,
      timezone: this.timezone.trim(),
      clients: this.canEditClients
        ? this.selectedClients.map((c: any) => c.id)
        : null,
    });
  }
}
